import { createTheme, type MantineColorsTuple } from '@mantine/core';

/**
 * The OPERATOR's theme, not a tenant's.
 *
 * White-labeling deliberately does not reach the dashboard: branding applies to
 * the three end-user-visible surfaces (email chrome, preference center, push
 * defaults) and nowhere else. Tenants never log in here, so letting their colours
 * leak into the console would only make one operator's tool look like several
 * different products.
 */
const brand: MantineColorsTuple = [
  '#e8f2ff', '#d0e0fb', '#9fbff5', '#6b9cf0', '#437fec',
  '#2b6dea', '#1e64ea', '#1254d0', '#0a4abb', '#003fa6',
];

export const theme = createTheme({
  primaryColor: 'brand',
  colors: { brand },
  defaultRadius: 'md',
  // A system font stack: an operator console is read for hours, and the platform
  // font is the one the reader's eye is already calibrated to.
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  fontFamilyMonospace:
    'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace',
  headings: { fontWeight: '600' },
  components: {
    Table: { defaultProps: { highlightOnHover: true, verticalSpacing: 'sm' } },
    Card: { defaultProps: { withBorder: true, padding: 'lg', radius: 'md' } },
    Button: { defaultProps: { radius: 'md' } },
    Badge: { defaultProps: { radius: 'sm', variant: 'light' } },
    Code: { defaultProps: { color: 'var(--mantine-color-default-hover)' } },
  },
});
